if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantInput = this.form.querySelector('[name=id]');
        this.variantInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.addEventListener('click', this.onSubmitButtonClick.bind(this), true);

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Form-level pending guard: prevent double-submit across sibling buttons
        if (this.form.dataset.submitting === 'true') return;
        this.form.dataset.submitting = 'true';

        var submitButton = evt.submitter || this.submitButton;

        this.handleErrorMessage();

        // Keep duplicate responsive forms in the same visual pending state.
        var allSubmitButtons = this.getRelatedSubmitButtons();
        this.setSubmitButtonsLoading(allSubmitButtons, true, submitButton);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          // Shopify accepts five bundled sections: include the visible cart page in the same response.
          ['main-cart-items', 'main-cart-footer'].forEach((id) => {
            const sectionId = document.getElementById(id)?.dataset.id;
            if (sectionId) sectionIds.push(sectionId);
          });
          formData.append('sections', [...new Set(sectionIds)].join(','));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let preorderCart = false;
        try {
          if(typeof Globo != 'undefined' && typeof Globo.Preorder != 'undefined'){
            const productId =  this.form.querySelector('[name="product_id"]')?.value;
            const variantId =  this.form.querySelector('[name="id"]')?.value;
            if(productId && variantId && Globo.Preorder.settings.page == 'product' && this.form.classList.contains('singleProductPreOrderForm')){
              const productJson = Globo.Preorder.settings.products.find(p => p.id.toString() === productId.toString());
              const profile = Globo.Preorder.getProductProfile(productJson, variantId);
              const quantityToStart = profile?.quantity?.quantityToStart;
              if(!profile.isPreorder && (profile.startCondition == 'quantity' || profile.startCondition == 'stock') && quantityToStart > 0){
                  if(parseInt(quantityToStart) < parseInt(formData.get('quantity'))){
                    const quantity = parseInt(formData.get('quantity'));
                    formData.set('quantity', quantityToStart)
                    alert(profile.message.outOfStockMessage.replace(':stock', Number(profile?.quantity?.quantityToStart)))
                    preorderCart = {
                      id: formData.get('id'),
                      quantity: parseInt(quantity) - parseInt(quantityToStart)
                    }
                  }
              }
            }
          }
        } catch (error) {}

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            document.dispatchEvent(new CustomEvent('globo.preorder.update.cart'))
            if(preorderCart){
              document.dispatchEvent(new CustomEvent('globo.preorder.add.preorder', {
                detail: {
                  preorderCart,
                  config
                }
              }))
            }else{
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                var soldOutMessage = submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                var submitSpan = submitButton.querySelector('span');
                if (submitSpan) submitSpan.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }

              if (!this.cart) {
                const cartSync = window.stonyLabCustomerCartSyncClient;
                if (cartSync && typeof cartSync.flush === 'function') {
                  const syncTimeout = new Promise((resolve) => setTimeout(resolve, 2500));
                  Promise.race([cartSync.flush(), syncTimeout]).finally(() => {
                    window.location = window.routes.cart_url;
                  });
                } else {
                  window.location = window.routes.cart_url;
                }
                return;
              }

              this.error = false;
              // Appstle captures cart rows 100 ms after /cart/add resolves. Apply bundled
              // cart sections before tearing down the product modal so it sees the new rows.
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
                cartRendered: this.cart.localName,
              });
              const renderCart = () => {
                this.cart.renderContents(response);
              };
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      renderCart();
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                renderCart();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            delete this.form.dataset.submitting;
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.setSubmitButtonsLoading(allSubmitButtons, false, submitButton, !this.error);
          });
      }

      getProductFormScope() {
        return this.closest('quick-add-modal, section[id^="MainProduct-"]') || this;
      }

      getRelatedProductForms() {
        const scope = this.getProductFormScope();
        const formId = this.form.getAttribute('id') || '';
        const baseFormId = formId.replace(/-desktop$/, '');
        const relatedIds = new Set([baseFormId, `${baseFormId}-desktop`]);

        return [...scope.querySelectorAll('form[data-type="add-to-cart-form"]')].filter(
          (form) => !formId || relatedIds.has(form.getAttribute('id') || '')
        );
      }

      getRelatedSubmitButtons() {
        const buttons = this.getRelatedProductForms().flatMap((form) => [
          ...form.querySelectorAll('button[type="submit"][name="add"]'),
        ]);
        return [...new Set(buttons.length ? buttons : [this.submitButton].filter(Boolean))];
      }

      setSubmitButtonsLoading(buttons, loading, activeButton = this.submitButton, clearDisabled = true) {
        buttons.forEach((button) => {
          if (loading) {
            button.setAttribute('aria-disabled', 'true');
            if (button === activeButton || button.getClientRects().length) {
              button.classList.add('loading');
              button.querySelector('.loading__spinner')?.classList.remove('hidden');
            }
            return;
          }

          button.classList.remove('loading');
          button.querySelector('.loading__spinner')?.classList.add('hidden');
          if (clearDisabled) button.removeAttribute('aria-disabled');
        });
      }

      onSubmitButtonClick(event) {
        const clickedButton = event.target.closest?.('button[type="submit"][name="add"]');
        if (!clickedButton || !this.contains(clickedButton) || clickedButton.disabled) return;
        if (clickedButton.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        // Ordinary products go straight to the theme's AJAX submit handler.
        const scope = this.getProductFormScope();
        if (!scope.querySelector('[dpo_add2cart]')) {
          if (scope.querySelector('#dpo_placeholder') && window.dpoData?.product &&
              (!window.dpoObserver?.allowProductIds ||
               window.dpoObserver.allowProductIds.includes(String(window.dpoData.product.id)))) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
          return;
        }
        const dpoButton = this.getRelatedSubmitButtons().find((button) => button.hasAttribute('dpo_add2cart'));
        if (!dpoButton) return;
        if (window.dpoOptions?.getAppearance?.() === 'popup_cart' && !dpoButton.classList.contains('force_submit')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (clickedButton.form !== dpoButton.form) {
          ['quantity', 'selling_plan'].forEach((name) => {
            const source = clickedButton.form?.elements.namedItem(name);
            const target = dpoButton.form?.elements.namedItem(name);
            if (source && target) target.value = source.value;
          });
        }
        const productForm = dpoButton.closest('product-form');
        productForm?.submitDynamicProductOptions(
          dpoButton.form, dpoButton, window.dpoData?.product || window.meta?.product, scope
        );
      }

      async submitDynamicProductOptions(form, submitButton, product, scope = this.getProductFormScope()) {
        if (scope.stonyLabDpoSubmitting || form.dataset.submitting === 'true') return;
        if (window.dpoOptions?.validateForm && !window.dpoOptions.validateForm()) return;

        let variantInput = form.querySelector('input[name="id"], input[name="id_prev"]');
        if (!variantInput && this.variantInput) {
          variantInput = this.variantInput.cloneNode(true);
          form.prepend(variantInput);
        }
        if (variantInput) { variantInput.name = 'id'; variantInput.disabled = false; }
        const originalVariantId = variantInput?.value;
        const dpoOptions = window.dpoOptions;
        const observer = window.dpoObserver;
        if (!product?.id || !variantInput?.value || !dpoOptions || !observer?.formValidateUrl) return;

        this.handleErrorMessage();
        scope.stonyLabDpoSubmitting = true;
        const buttons = this.getRelatedSubmitButtons();
        this.setSubmitButtonsLoading(buttons, true, submitButton);
        let handedOffToProductForm = false;

        try {
          dpoOptions.checkPriceHandler?.();
          if (dpoOptions.customValidation && dpoOptions.customValidation() === false) return;
          const payload = new URLSearchParams();
          payload.append('options[0]', 'dummy_option');

          (dpoOptions.options || []).forEach((option) => {
            if (option.items?.length && ['drop_down', 'radio', 'checkbox', 'multiple'].includes(option.type)) {
              if (option.elm?.disabled) return;
              option.items.forEach((item) => {
                const element = item.elm;
                if (
                  !element ||
                  element.disabled ||
                  (!element.selected && !element.checked) ||
                  element.closest?.('.ihidden')
                )
                  return;

                const name = (option.elm || element).name.replace(/\[\]$/, '');
                payload.append(`${name}[]`, element.value);
              });
              return;
            }

            const element = option.elm;
            const filename = element?.getAttribute?.('filename');
            if (
              !element ||
              element.disabled ||
              (option.hide_on_focus && element.value === option.default_value && option.type !== 'slider') ||
              (!element.value && !filename) ||
              element.closest?.('.ihidden')
            )
              return;
            payload.append(element.name, filename || element.value);
          });

          scope.querySelectorAll('.option-qty:not(.use_product_qty)').forEach((input) => {
            payload.append(input.name, String(Number(input.value) > 0 ? Number(input.value) : 1));
          });

          const quantity = new FormData(form).get('quantity') || dpoOptions.getQtyField?.().value || '1';
          payload.append('qty', quantity);
          if (dpoOptions.variantUseProductName) payload.append('variant_use_product_name', '1');
          payload.append('price_handler', String(observer.priceHandler ?? 2));
          payload.append('cart_transform_relative_pricing', String(observer.cartTranformRelativePricing || 0));
          payload.append('template_id', String(observer.forceLoadingTemplate || 0));
          payload.append('variant_id', dpoOptions.skipVariantCreation ? '0' : variantInput.value);
          payload.append('product_id', String(product.id));
          payload.append('customer_id', String(window.meta?.page?.customerId || 0));
          payload.append('tier_prices', JSON.stringify(dpoOptions.tierPrices || []));
          const cartOptionProperties = dpoOptions.createShopifyCartProperties?.(true) || {};

          const response = await fetch(observer.formValidateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: payload.toString(),
          });
          const data = await response.json();
          if (!data.variant_id && dpoOptions.skipVariantCreation) data.variant_id = variantInput.value;
          if (!response.ok || data.notice || data.error || !data.variant_id) {
            throw new Error(data.error || 'There was a problem adding the product to cart.');
          }

          form.querySelectorAll('[data-stony-dpo-property]').forEach((input) => input.remove());
          variantInput.value = data.variant_id;
          const properties = { ...cartOptionProperties };
          if (data._dpo_id) properties._dpo_id = data._dpo_id;
          if (data._dpo_hash) properties.__dpo_hash = data._dpo_hash;
          if (data._dpo_v) properties._dpo_v = data._dpo_v;
          if (data._dpo_id) properties.__dpo_p = JSON.stringify(cartOptionProperties);

          Object.entries(properties).forEach(([key, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key.replace(/\[/g, '(').replace(/\]/g, ')')}]`;
            input.value = typeof value === 'string' ? value : JSON.stringify(value);
            input.dataset.stonyDpoProperty = 'true';
            form.appendChild(input);
          });

          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          handedOffToProductForm = form.dataset.submitting === 'true';
        } catch (error) {
          console.error('DPO add to cart failed:', error);
          this.handleErrorMessage(error.message || 'There was a problem adding the product to cart.');
        } finally {
          scope.stonyLabDpoSubmitting = false;
          // The AJAX handler has already captured FormData; keep the selected base variant for the next add.
          if (variantInput) variantInput.value = originalVariantId;
          if (!handedOffToProductForm) this.setSubmitButtonsLoading(buttons, false, submitButton);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        const forms = this.getRelatedProductForms();
        (forms.length ? forms.map((form) => form.closest('product-form')) : [this]).forEach((productForm) => {
          const wrapper = productForm?.querySelector('.product-form__error-message-wrapper');
          if (!wrapper) return;
          wrapper.toggleAttribute('hidden', !errorMessage);
          const message = wrapper.querySelector('.product-form__error-message');
          if (message && errorMessage) message.textContent = errorMessage;
        });
      }

    }
  );
}
